import { useTranslation } from "react-i18next";
import * as z from "zod";

export const useRewardPayOutSchema = () => {
  const { t } = useTranslation();

  return z.object({
    name: z
      .string({
        required_error: t(
          "referral.payOutModal.form.fields.name.errors.required",
        ),
      })
      .trim()
      .min(1, t("referral.payOutModal.form.fields.name.errors.required")),
    bankAccountNumber: z
      .string({
        required_error: t(
          "referral.payOutModal.form.fields.name.errors.required",
        ),
      })
      .trim()
      .min(
        1,
        t("referral.payOutModal.form.fields.bankAccountNumber.errors.required"),
      ),
  });
};
